// based on 16-bit Arrays, a random value between 0-(2^16-1) is created and divided by (2^16-1) to create a value [0,1]

import { BASE_16 } from '../number-constants';

// use as replacement for Math.random() as it's insecure/vulnerable
export function secureRandom(): number {
  // eslint-disable-next-line no-restricted-globals
  const [random16bitNumber] = window.crypto.getRandomValues(new Uint16Array(1));
  return random16bitNumber / (Math.pow(2, BASE_16) - 1);
}
